import './Login.css';

import { Control, LocalForm } from 'react-redux-form';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useState, useEffect, Component } from 'react';

import fuseLogo from './assets/fuse-logo.svg';
import fuseBackground from './assets/fuse-background.png';
import Footer from '../Footer';
import Alert from "../../container/Alert";

class Login extends Component {
  state = {
    ipAddress: '',
    deviceInfo:''
  };

  componentDidMount() {
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(result => {
        this.setState({ ipAddress: result.ip });
      });

      const deviceInfo1 = (function () {
        const module = {
            options: [],
            header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
            dataos: [
                { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
                { name: 'Windows', value: 'Win', version: 'NT' },
                { name: 'iPhone', value: 'iPhone', version: 'OS' },
                { name: 'iPad', value: 'iPad', version: 'OS' },
                { name: 'Kindle', value: 'Silk', version: 'Silk' },
                { name: 'Android', value: 'Android', version: 'Android' },
                { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
                { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
                { name: 'Macintosh', value: 'Mac', version: 'OS X' },
                { name: 'Linux', value: 'Linux', version: 'rv' },
                { name: 'Palm', value: 'Palm', version: 'PalmOS' }
            ],
            databrowser: [
                { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
                { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
                { name: 'Safari', value: 'Safari', version: 'Version' },
                { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
                { name: 'Opera', value: 'Opera', version: 'Opera' },
                { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
                { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
            ],
            init () {
                const agent = this.header.join(' '),
                    os = this.matchItem(agent, this.dataos),
                    browser = this.matchItem(agent, this.databrowser);

                return { os, browser };
            },
            matchItem (string, data) {
                let i = 0,
                    j = 0,
                    html = '',
                    regex,
                    regexv,
                    match,
                    matches,
                    version;

                for (i = 0; i < data.length; i += 1) {
                    regex = new RegExp(data[i].value, 'i');
                    match = regex.test(string);
                    if (match) {
                        regexv = new RegExp(`${data[i].version}[- /:;]([\\d._]+)`, 'i');
                        matches = string.match(regexv);
                        version = '';
                        if (matches) { if (matches[1]) { matches = matches[1]; } }
                        if (matches) {
                            matches = matches.split(/[._]+/);
                            for (j = 0; j < matches.length; j += 1) {
                                if (j === 0) {
                                    version += `${matches[j]}.`;
                                } else {
                                    version += matches[j];
                                }
                            }
                        } else {
                            version = '0';
                        }
                        return {
                            name: data[i].name,
                            version: parseFloat(version)
                        };
                    }
                }
                return { name: 'unknown', version: 0 };
            }
        };
        const e = module.init();

        return `{"os":{"name":"${
                                     e.os.name
                                     }","version":"${
                                     e.os.version
                                     }"},"browser":{"name":"${
                                     e.browser.name
                                     }","version":"${
                                     e.browser.version
                                    }"},"navigator":{"userAgent":"${
                                     navigator.userAgent
                                     }","appVersion":"${
                                     navigator.appVersion
                                     }","platform":"${
                                     navigator.platform
                                     }","vendor":"${
                                     navigator.vendor
                                     }"}}`;
    }());

    this.setState({ deviceInfo: deviceInfo1});
  }

  render() {
    const print = status => {
      if (status.payload) {
        return status.payload.response;
      }
    };
    const { login, clearData, status } = this.props;

    return (
      <div className="main">
        <Alert
          title="Exception"
          message={print(this.props.status)}
          reset = {this.props.resetPopError}
          logout = {()=>{}}
        />
        <div className="login">
          <div className="logo">
            <img alt="" src={fuseLogo} width="288" height="150" />
          </div>
          <LocalForm
            onSubmit={({ username, password }) =>
              login(username, password, this.state.ipAddress,this.state.deviceInfo)
            }
            className="form"
          >
            <fieldset>
              <label>
                <FormattedMessage
                  id="login.from.username"
                  defaultMessage="User name / Email Address"
                />
              </label>
              <Control.text model=".username" autoFocus required />
            </fieldset>
            <fieldset>
              <label>
                <FormattedMessage
                  id="login.form.password"
                  defaultMessage="Password"
                />
              </label>
              <Control.password model=".password" required />
            </fieldset>
            <div className="button-container" style={{ textAlign: 'left', width: 420 }}>
              <button className="button" style={{ marginRight: '20px' }}>
                Sign In
              </button>
              <Link to="/en-CA/onboard">
                <button className="button" style={{ marginRight: '20px' }} type="button">
                  REGISTER CUSTOMER ACCOUNT
                </button>
              </Link>
            </div>
            <br />

            <div style={{ fontSize: '14px' }}>
              <a target="_blank" rel="noopener" style={{ color: '#1f5c71', cursor: 'pointer' }}
                  onClick={()=>this.props.gotoPasswordforgot()}
              >
                Forgot your password?
              </a>
            </div>
          </LocalForm>
          <div className="background">
            <img alt="" src={fuseBackground} height="100%" width="100%"/>
            <div className="title-welcome-container">
            <span className="title-welcome">Welcome to FUSE</span><p>
            <span className="title-welcome-sub">Sign in to access your account</span></p></div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  status: PropTypes.object
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/views/Login/index.js